/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MetadataSchema } from './MetadataSchema';
import {
	MetadataSchemaFromJSON,
	MetadataSchemaFromJSONTyped,
	MetadataSchemaToJSON,
} from './MetadataSchema';

/**
 *
 * @export
 * @interface MetadataSchemaResponse
 */
export interface MetadataSchemaResponse {
	/**
	 *
	 * @type {MetadataSchema}
	 * @memberof MetadataSchemaResponse
	 */
	item?: MetadataSchema;
}

/**
 * Check if a given object implements the MetadataSchemaResponse interface.
 */
export function instanceOfMetadataSchemaResponse(value: object): boolean {
	let isInstance = true;

	return isInstance;
}

export function MetadataSchemaResponseFromJSON(json: any): MetadataSchemaResponse {
	return MetadataSchemaResponseFromJSONTyped(json, false);
}

export function MetadataSchemaResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): MetadataSchemaResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		item: !exists(json, 'item') ? undefined : MetadataSchemaFromJSON(json['item']),
	};
}

export function MetadataSchemaResponseToJSON(value?: MetadataSchemaResponse | null): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		item: MetadataSchemaToJSON(value.item),
	};
}
